import { useCallback, useEffect, useRef, useState } from 'react';

const DEFAULT_RESET_MS = 2000;

export default function useCopiedFeedback(resetMs = DEFAULT_RESET_MS) {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearResetTimer = () => {
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const resetCopied = useCallback(() => {
    clearResetTimer();
    setCopied(false);
  }, []);

  const markCopied = useCallback(() => {
    clearResetTimer();
    setCopied(true);
    timeoutRef.current = setTimeout(() => {
      setCopied(false);
      timeoutRef.current = null;
    }, resetMs);
  }, [resetMs]);

  useEffect(() => () => clearResetTimer(), []);

  return { copied, markCopied, resetCopied };
}
